import Vue from 'vue';
import axios from 'axios';
import '../../../filters';
import moment from 'moment';
import users from '../../../users';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';


export default {
  name: 'createBillingCycle',
  mixins: [users, validationMixin],
  components: {
    TreeSelect: require('../../../customcontrols/selectOfTree.vue').default,
    dateTimePickerComp: require('../../../customcontrols/dateTimePicker.vue').default
  },
  props: {
    parent: {
      type: Object,
      required: true
    },
  },
  data: function () {
    return {
      billingGroups: [],
      billingGroup: '',
      description: '',
      cutOffDate: new Date(),
      cycleLength: 1,
      globalPayByDate: new Date(),
      period: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      periods: [],
      years: []
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.fillMonthYears();
    this.getBillingGroupsForNewCycle();
  },
  mounted() {
    
  },
  methods: {
    fillMonthYears() {
      this.periods = [];
      for (var i = 1; i <= 100; i++) {
        this.periods.push(i);
      }

      this.years = [];
      for (var i = 1980; i <= 2080; i++) {
        this.years.push(i);
      }
    },
    getBillingGroupsForNewCycle() {
      axios.post('/Billing/GetBillingGroupsForNewCycle')
        .then(response => {
          if (response.status == 200) {
            console.log(response.data);
            this.billingGroups = [];

            for (var i = 0; i < response.data.length; i++) {
              this.billingGroups.push({
                id: response.data[i].billingGroupId,
                label: response.data[i].name,
              });
            }

            this.billingGroup = '';
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    cancelOpenNewCycle() {
      this.parent.cancelOpenNewCycle();
    },
    createBillingCycle() {
      var parameters = {
        BillingGroupId: this.billingGroup,
        CutOffDate: moment(this.cutOffDate, "DD/MM/YYYY").add(1, 'days'),
        Description: this.description,
        CycleLength: this.cycleLength,
        PayByDate: moment(this.globalPayByDate, "DD/MM/YYYY").add(1, 'days'),
        BillingPeriodMonth: this.period,
        BillingPeriodYear: this.year,
      };

      axios.post('/Billing/CreateBillingCycle', parameters
      )
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('billing.billingCycleCreatedSuccessfully'), 2);
            this.parent.createBillingCycleComplete();
          }
        })
        .catch(err => {
          this.$alertMsg(err.response.data);
        });
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
  },
}
